import { SignUP } from './signupSlice';
// A mock function to mimic making an async request for data
export function sendSignUp(signup: SignUP) {
  return new Promise<{data: SignUP}>((resolve) => setTimeout(() => resolve({ data: signup }), 500));
}
